module.exports = __webpack_public_path__ + "img/disrupt.5ed8ec85.png";